import styled from 'styled-components';

import theme from '@theme';

export const Wrapper = styled.div`
  width: 507px;

  @media (max-width: ${theme.breakPoint.WIDE_DESKTOP}) {
    width: 320px;
  }
  @media (max-width: ${theme.breakPoint.DESKTOP}) {
    width: 170px;
  }
  @media (max-width: ${theme.breakPoint.TABLET}) {
    width: 100%;
  }
  @media (max-width: ${theme.breakPoint.PHONE}) {
    width: 100%;
  }

  &:hover {
    background-color: white;
  }

  img {
    opacity: 0.8;
  }
`;
